<template>
    <div v-if="isLoggedIn" class="container page">
        <section v-if="displayPart==-1" class="card card-default">
            <div class="col-sm-8"><h5>{{awardTitle}} is Closed</h5></div>

        </section>

        <section v-if="displayPart==10" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>{{awardTitle}}</h5></div>
                    <div class="col-sm-4">   
                    </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="nomMessage">
                    <b-card no-body>
                        <b-tabs pills vertical lazy card no-nav-style nav-wrapper-class="col-12 col-md-4" content-class="col-12 col-md-8">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/ceostmclaimscco.jpg')" alt=""></b-img></div>
                                    <div class="mb-4 text-center ceo">Quinten Matthew</div>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/ceostmclaimshead.jpg')" alt=""></b-img></div>
                                    <div class="mb-1 text-center ceo">Rowan de Villiers</div>
                                </template>
                                <b-card-text class="text-left">
                                    <p><b>Howzit everyone!</b></p>
                                    <p>
                                        It brings us an immense pleasure to introduce our Claims Recognition Programme
                                        (Claims Laduma Recognition Awards), a special initiative designed to celebrate and
                                        honour the hard work, dedication, and outstanding achievements of our exceptional
                                        Claims Team.
                                    </p>

                                    <p>As you know, in our industry, the ability to respond swiftly, compassionately, and
                                    efficiently is what sets us apart (differentiator). The Claims Team plays a crucial role in
                                    delivering on our promise to our customers, providing support when it is needed most.
                                    This program is our way of acknowledging the tireless effort each member puts in to
                                    uphold the standards of excellence for which we are known.</p>

                                    <p>Through this platform, we will recognize those who go above and beyond, driving
                                    our success and contributing to our collective growth. Your dedication does not just
                                    impact our business, it strengthens our relationships with Clients/Brokers and builds a
                                    foundation for continued success.</p>

                                    <p>We want to personally thank everyone of you for your commitment, your passion, and
                                    your relentless pursuit of excellence. Today, we celebrate you. Your hard work is the
                                    heartbeat of Santam, and together, we will continue to set new benchmarks in Claims.</p>

                                    <p><b>Here is to continued success!  This is freedom!</b></p>
                                    <p>Warm regards,</p>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <p><b>Quinten Matthew</b></p>
                                            <p>Chief Commercial Officer</p>
                                        </div>
                                        <div class="col-md-5">
                                            <p><b>Rowan de Villiers</b></p>
                                            <p>Executive Head: Claim</p>
                                        </div>
                                    </div>

                                </b-card-text>
                            </b-tab>

                            <hr />
                            <div class="text-right mt-3 mb-3">
                                <div v-if="isAwardRunning">
                                    <a class="btn btn-primary" href="#" @click.prevent="showNomForm()" v-b-tooltip.hover.left title="Create a new Award nomination">New Award Nomination</a>
                                </div>
                                <div v-else class="alert alert-secondary" role="alert">Nominations are now closed</div>
                            </div>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </section>


        <template v-if="displayPart==0">
            <div class="row mb-2">
                <div class="col-sm-8">
                    <h5>{{awardTitle}}</h5>
                    Select an Award below, then complete your nomination.
                </div>
                <div class="col-sm-4 text-right">
                    <a href="#" @click.prevent="displayPart=10" class="btn btn-secondary">Back</a>
                </div>
            </div>
            <!--
    { value: '', text: '--- Please select an option ---' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Team', text: 'Team' },
    { value: 'Simple Innovative Solutions', text: 'Simple Innovative Solutions' },
    { value: 'Exceptional Service', text: 'Exceptional Service < 35' },
    { value: 'General employee', text: 'General employee (non-management)' },
        -->
            <section class="card mb-4 nomAwardCategory3">
                

                <b-tabs v-model="tabIndex" lazy card nav-class="selcatNav">
                    <b-tab title="iLanga" @click="awardCatSelected('iLanga')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_langa.jpg" class="w-100" /></div>
                            <h3>iLanga</h3>
                            <hr />
                            <p>The iLanga award is recognition of a JG 5 or 6 who has displayed servant leadership and inspired their division/team to improve performance, experience, or drive innovation. Evidenced through high performance; Display of the Santam values; Skills development; Santam Experience.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Morning Star" @click="awardCatSelected('Morning Star')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_morningstar.jpg" class="w-100" /></div>
                            <h3>Morning Star</h3>
                            <hr />
                            <p>The morning star award is recognition of an outstanding leader (JG7 & 8) who has shown leadership capability. This leader has made an impact in their team. Evidenced through delivery of outstanding overall team performance and display of outstanding leadership qualities.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="iQhawe" @click="awardCatSelected('iQhawe')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_iqhawe.jpg" class="w-100" /></div>
                            <h3>iQhawe</h3>
                            <hr />
                            <p>The iQhawe award is recognition of any individual within Claims who has delivered the Santam Experience to clients. Evidenced through delivery of outstanding Santam experience metrics together with a meaningful contribution to client.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Tinyeleti" @click="awardCatSelected('Tinyeleti')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_tinyeleti.jpg" class="w-100" /></div>
                            <h3>Tinyeleti</h3>
                            <hr />
                            <p>This award is recognition of a team within in Claims who has delivered the Santam Experience to clients through collaboration and a single-minded service excellence. Evidenced through delivery of outstanding Santam experience metrics.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Suiderkruis" @click="awardCatSelected('Suiderkruis')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_suiderkruis.jpg" class="w-100" /></div>
                            <h3>Suiderkruis</h3>
                            <hr />
                            <p>This is in recognition of a group/ team within Claims who, through their contribution, have brought an innovation to the division and moved the business forward. Evidenced through delivery of solution/project with discernible value to Claims.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Selemela" @click="awardCatSelected('Selemela')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_selemela.jpg" class="w-100" /></div>
                            <h3>Selemela</h3>
                            <hr />
                            <p>This award is in recognition of any employee in Claims who has achieved exceptional performance in a support role in Claims, the individual has supported and displayed passion to live innovation by renewing processes, procedures and cultivating “new life” for Santam.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Nwedzi" @click="awardCatSelected('Nwedzi')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_nwedzi.jpg" class="w-100" /></div>
                            <h3>Nwedzi</h3>
                            <hr />
                            <p>The Nwedzi award is in recognition of the brightest, up and coming employee in our client facing environments, recognising outstanding contribution and performance. This JG 8-12 star has consistently hit and exceeded the performance metrics.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Molalatladi" @click="awardCatSelected('Molalatladi')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_molathladi.jpg" class="w-100" /></div>
                            <h3>Molalatladi</h3>
                            <hr />
                            <p>The Molalatladi award is in recognition of outstanding administrative support at all JGs. Evidenced through delivery of outstanding overall performance.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Kham" @click="awardCatSelected('Kham')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamclaimsladuma_kham.jpg" class="w-100" /></div>
                            <h3>Kham</h3>
                            <hr />
                            <p>The Kham award is in recognition of an individual who has displayed exceptional technical expertise. Evidenced through delivery of outstanding overall performance, with particular emphasis on financial metrics. This is open to all individuals who perform technical support role in Claims.</p>
                        </b-card-text>
                    </b-tab>

                </b-tabs>
            </section>

            <section class="card card-default mt-3" v-if="fNomination.form.awardCat !== null">
                <div class="card-header">
                    <h5>Nomination for: <b class="darkShade">{{ fNomination.form.awardCat }}</b></h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6"><strong>Nominee{{isNomSingleOnly ? "" : "s"}}:</strong></div>
                        <div class="col-sm-6 text-right"></div>
                    </div>
                    <div v-for="r in selectedNominees" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div v-if="selectedNominees.length===0" class="text-danger">Please select nominee{{isNomSingleOnly ? "" : "s"}}.</div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm">{{selectedNominees.length===0 ? 'Select' : 'Update'}}  Nominee{{isNomSingleOnly ? "" : "s"}}</b-button>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                    </div>

                    <hr />
                    <b-form @submit.prevent="onSubmitAward" novalidate>
                        <!--
        <b-form-group id="groupAwardCat" label-for="selectAwardCat" label="Award Category:" :invalid-feedback="fNomination.errors.awardCat" description="">
            <b-form-select id="selectAwardCat" v-model="fNomination.form.awardCat" :options="awardCatList" value-field="value" text-field="text" :state="fNomination.state.awardCat" />
        </b-form-group>
           -->
                        <b-form-group id="groupMotivation" label-for="txtMotivation" label="Motivation:" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                            <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="Provide a short motivation" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupaction" label-for="txtaction" label="Actions Taken:" :invalid-feedback="fNomination.errors.action" :description="1500-fNomination.form.action.length + ' characters remaining'">
                            <b-form-textarea id="txtaction" v-model="fNomination.form.action" :state="fNomination.state.action" placeholder="Describe action taken" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupimpact" label-for="txtImpact" label="Impact:" :invalid-feedback="fNomination.errors.impact" :description="1500-fNomination.form.impact.length + ' characters remaining'">
                            <b-form-textarea id="txtImpact" v-model="fNomination.form.impact" :state="fNomination.state.impact" placeholder="Impact thereof" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <hr />
                        <template v-if="isShowEndorser">
                            <div class="row">
                                <div class="col-sm-6"><strong>Endorser for your nomination:</strong></div>
                                <div class="col-sm-6 text-right"></div>
                            </div>
                            <div v-for="r in selectedNominators" :key="r._rowNum" class="row">
                                <template v-if="r.isEntireDivision">
                                    <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                                    <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                                </template>
                                <template v-else>
                                    <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                                    <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                                    <div class="col">{{ r.division }}</div>
                                </template>
                            </div>
                            <div v-if="selectedNominators.length!==2" class="text-danger">Select an endorser to support your nomination.</div>
                            <div class="mt-1"><b-button type="button" pill @click="$bvModal.show('modalChooseNominators')" variant="primary" size="sm">{{selectedNominators.length===0 ? 'Select' : 'Update'}} Endorser</b-button></div>
                            <!--<div class="text-center"><b-button type="button" @click="$bvModal.show('modalChooseNominators')" variant="primary">Select Nominators</b-button></div>-->
                            <hr />
                        </template>

                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </template>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>{{awardTitle}}</h5>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">{{fNomination.form.awardCat}} Nomination</h4>
                    <p>Successfully submitted the {{fNomination.form.awardCat}} Nomination.</p>
                    <p>Your reference for this nomination is: <b>{{awardId}}</b></p>
                </b-alert>

                <b-button type="button" pill @click="displayPart=10" variant="primary">Ok</b-button>

            </div>
        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" :title="'NOMINEE' + (isNomSingleOnly ? '' : 'S')" hide-footer size="xl" no-close-on-backdrop>
            <member-select :title="'Select Nominee' + (isNomSingleOnly ? '' : 's') + ' for the ' + fNomination.form.awardCat"
                           :selectedTitle="isNomSingleOnly ? 'Selected nominee' : 'Selected nominees'"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominees"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           excludeDivisionCode=""
                           memberType="santam-claims"
                           :isSingle ="isNomSingleOnly"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

        <!-- Modal - Nominators -->
        <b-modal id="modalChooseNominators" title="NOMINATORS" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select an endorser to support your nomination"
                           selectedTitle="Selected endorser to support your nomination"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominators"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           :isSingle="true"
                           memberType="santam-claims"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominators')">Done</b-button></div>
        </b-modal>


    </div>

</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
	//import ContentDb from '@/components/ContentDb';



    export default {
        name: 'SanlamAward',
        components: { MemberSelect, SitecodeImage },//, ContentDb },
        data() {
            return {
                isAwardRunning: true, //when false, nominations are closed

                awardTitle: "Santam Claims Laduma Recognition Awards",
                displayPart: 10, //Sanlam Life &amp; Savings CEO Award:   -1: Closed  10:Open
                fNomination: { 
                    form: { awardCat: 'iLanga', motivation: '', action: '', impact: '' }
                },
                tabIndex: 0,

                selectedNominees: [],
                selectedNominators: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',
                currentIdeaRowNum: null,
                modalPart: 0,

                //awardCatList: [
                //    { value: '', text: '--- Please select an option ---' },
                //    { value: 'One Sanlam Experience Award: Emerging', text: 'One Sanlam Experience Award: Emerging' },
                //    { value: 'Innovation', text: 'Innovation' },
                //    { value: 'Santam Experience', text: 'Santam Experience' },
                //    { value: 'Collaboration', text: 'Collaboration' },
                //    { value: 'Everyday Hero', text: 'Everyday Hero' },
                //    { value: 'Rising Star', text: 'Rising Star' }
                //],

                awardId: 0

            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn && this.memberDivisionCode == 'stm_6009'; //Only stm_6009
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            currentIdea() {
                if (this.currentIdeaRowNum === null) return null;
                return this.ideas[this.currentIdeaRowNum];
            },
            isNomSingleOnly() {
                switch (this.fNomination.form.awardCat) {
                    case "Tinyeleti":
                    case "Suiderkruis":
                        return false; //team
                    default:
                        return true; //single
                }


                return false;// !this.fNomination.form.awardCat.startsWith("Innovation Award");

                //return this.fNomination.form.awardCat == 'Leadership with Excellence'
                //    || this.fNomination.form.awardCat == 'Rising Star'
                //    || this.fNomination.form.awardCat == 'Everyday Hero';
            },
            isShowEndorser() {
                switch (this.fNomination.form.awardCat) {
                    case "iLanga":
                    case "iQhawe":
                    case "Tinyeleti":
                        return false;
                    default:
                        return true;
                }
            }

        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => { 

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {
            showNomForm() {
                this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm
                this.displayPart = 0;
                this.$nextTick(() => {
                    this.tabIndex = 0; //Select first tab
                    this.awardCatSelected('iLanga'); //ensure got awardCat for first tab
                });
            },
            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },


            awardCatSelected(awardCat) {
                this.fNomination.form.awardCat = awardCat;
                this.selectedNominees = [];
            },

            onSubmitAward() {
                try {

                    

                    if (this.selectedNominees.length === 0) {
                        this.msgBox('Please select at least one nominee.', 'Nominees are required');
                        return;
                    }

                    if (this.isNomSingleOnly && this.selectedNominees.length !== 1) {
                        this.msgBox('Only a single nominee may be selected.', 'Single Nominees');
                        return;
                    }

                    let nominators;
                    if (this.isShowEndorser) {
                        nominators = this.selectedNominators.filter(item => !item.isEntireDivision);
                        if (nominators.length == 0) {
                            this.msgBox('Please select an endorser.', 'An endorser is required');
                            return;
                        }
                    } else {
                        this.selectedNominators = [];
                        nominators = [];
                    }

                    this.formSetState(this.fNomination, true);//formObj, resetState, resetForm

                    this.fNomination.form.nominees = this.selectedNominees.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);

                    var payload = { ...this.fNomination.form, awardType: "santam-claims" }
                    
                    if (nominators.length !== 0) {
                        payload.endorserMemberId = nominators[0].memberId;
                    }

                    return axios
                        .post(
                            '/api/SanlamAward/newnomination',
                            payload
                        )
                        .then(({ data }) => {
                            console.log(data);

                            const er = data.errorMessage;
                            this.awardId = data.awardId;

                            if (data.awardId == 0) {
                                this.msgBox('An unexpected error occured: ' + er)
                            } else {
                                this.displayPart = 1;
                                //this.msgBox('Successfully submitted nomination');
                            }
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fNomination.errors = error.response.data.formErrors;
                                this.formSetState(this.fNomination);
                            }
                        })
                        ;
                } catch (err) {
                    this.msgBox(err.message, 'An unexpected error occured submitting the nomination');
                }
            },

        }




    }
</script>
